import { render, staticRenderFns } from "./AccountMetadataDetail.vue?vue&type=template&id=0215a868&"
import script from "./AccountMetadataDetail.vue?vue&type=script&lang=ts&"
export * from "./AccountMetadataDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports